import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { PartialProduct } from '../interfaces/PartialProduct';
@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  constructor(private http: HttpClient) { }
  getOrderByUserId(id: string, page: any): Observable<any> {
    return this.http.get(environment.Server_URL + '/orderuser/' + id + `?page=${page}`);
  }
  changeStatus(id: any, status: any, reason: any): Observable<any> {
    const body = new FormData();
    body.append('order_status', status);
    body.append('reason', reason);
    return this.http.post(`${environment.Server_URL}/updatestatus/` + id, body);
  }
  updateQty(status: any, orderid: any): Observable<any> {
    const body = new FormData();
    body.append('order_status', status);
    body.append('order_id', orderid);
    return this.http.post(`${environment.Server_URL}/orders/reject`, body);
  }
  addOrder(formData: FormData): Observable<any> {
    return this.http.post(
      `${environment.Server_URL}/orders`,
      formData
    );
  }
  getByIds(ids: number[],) {
    return this.http.post(`${environment.Server_URL}/stocks/by-ids`, {
      ids: ids
    });
  }
  getClientById(clientId: number): Observable<any> {
    return this.http.get(`${environment.Server_URL}/clients/${clientId}`);
  }
  payOrder(orderId: number): Observable<any> {
    return this.http.post(
      `${environment.Server_URL}/orders/${orderId}/pay`,
      {} // Kashier يحتاج body فاضي
    );
  }
  getOrderById(orderId: number): Observable<any> {
    return this.http.get(`${environment.Server_URL}/orders/${orderId}`);
  }
}
